import { Component, Inject, OnInit, Optional } from '@angular/core';
import { TT_VIEW_NAVIGATOR, TTViewNavigator, useNavigatorFor } from '@app/modal/state-modal/state-modal.component';
import { ModalService } from '@app/core/services/modal.service';
import { SrCheckListLdGet, SrChecklistService } from '@app/services/sr-checklist.service';

@Component({
    selector: 'tt-sr-check-list-ld',
    templateUrl: './sr-check-list-ld.component.html',
    styleUrls: ['./sr-check-list-ld.component.css'],
    standalone: false,
})
export class SrCheckListLdComponent implements OnInit {
    public page?: SrCheckListLdGet;
    public refundInputKeyno = '0';
    public saving = false;
    public calculating = false;
    public deleting = false;

    constructor(
        private readonly checklist: SrChecklistService,
        private readonly modal: ModalService,
        @Optional() @Inject(TT_VIEW_NAVIGATOR) private navigator?: TTViewNavigator,
    ) { this.navigator = useNavigatorFor(navigator, this); }

    public async ngOnInit(): Promise<void> {
        this.refundInputKeyno = String(this.navigator?.params['srrefundinput_keyno'] ?? '0');
        this.page = await this.checklist.getLossDamage({
            checklistdata_keyno: String(this.navigator?.params['checklistdata_keyno'] ?? ''),
            srrefundinput_keyno: this.refundInputKeyno,
        });
    }

    public clearSignature(): void { if (this.page) this.page.ld_signature = ''; }

    public async calculateAmount(): Promise<void> {
        if (!this.page || this.calculating) return;
        this.calculating = true;
        try {
            const value: unknown = await this.modal.showCalculator('expense_amount', undefined, this.page.expense_amount);
            if (typeof value === 'string' || typeof value === 'number') this.page.expense_amount = value;
        } finally { this.calculating = false; }
    }

    public async saveChanges(): Promise<void> {
        if (!this.page || this.saving || this.deleting) return;
        this.saving = true;
        try {
            const response = await this.checklist.saveLossDamage(this.page);
            if (response.errorcode !== '0') await this.showWarning(response.errormessage);
            else await this.navigator?.back();
        } finally { this.saving = false; }
    }

    public async deleteValues(): Promise<void> {
        if (!this.page || this.deleting || this.saving) return;
        this.deleting = true;
        try {
            const response = await this.checklist.deleteLossDamage(this.page);
            if (response.errorcode !== '0') await this.showWarning(response.errormessage);
            else await this.navigator?.back();
        } finally { this.deleting = false; }
    }

    private showWarning(message: string): Promise<void> {
        return this.modal.show({ type: 'warning', title: 'Varsel', message, buttons: [{ label: 'OK', cssClass: 'btn-warning', close: true }] });
    }
}
